export default "__VITE_ASSET__EYyakvmY__"